import React, { useEffect } from 'react';

import classNames from 'classnames';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getStructureThunk, studyDetailsState } from 'redux/study/studyDetails.slice';
import Card from 'components/Card/Card';
import useRouterHelper from 'hooks/useRouterHelper';
import NewStructureItem from 'views/Study/components/Forms/NewStructureItem/NewStructureItem';

import TeachingStructureHeader from './components/TeachingStructureHeader';
import TeachingStructureChapter from './components/TeachingStructureChapter';
import TeachingStructureAssignment from './components/TeachingStructureAssignment';
import style from './teachingStructure.module.scss';

const TeachingStructure: React.FC<{ parentId: string; lessonId: string }> = ({
  parentId,
  lessonId,
}) => {
  const dispatch = useAppDispatch();
  const { teachingStructure, teachingStructureLoading } = useAppSelector(studyDetailsState);

  const { routePush, query } = useRouterHelper();

  const getStructure = () => {
    dispatch(getStructureThunk(parentId));
  };

  useEffect(() => {
    getStructure();
  }, [parentId]);

  const printStructure = (activeStructureItem: string) => {
    const items = teachingStructure.filter(obj => {
      return obj.parent_id === activeStructureItem;
    });

    if (!items.length) {
      return <></>;
    }
    const sortedTeachingStructure = [];
    sortedTeachingStructure.push(
      <ul key={activeStructureItem}>
        {items.map(obj => {
          const sortedTeachingStructureLocal = [];
          sortedTeachingStructureLocal.push(
            <li key={obj.id + obj.title}>
              {
                <TeachingStructureChapter
                  callback={getStructure}
                  title={obj.title}
                  id={obj.id}
                  lessonId={lessonId}
                  assignments={obj.assignments.length}
                  obj={obj}
                />
              }
              {lessonId === obj.id && query.newItem === 'true' && (
                <ul>
                  <li>
                    <NewStructureItem callback={getStructure} />
                  </li>
                </ul>
              )}

              {obj.assignments.length > 0 && (
                <ul>
                  {obj.assignments.map(assignment => {
                    return (
                      <TeachingStructureAssignment
                        key={assignment.id}
                        lessonId={lessonId}
                        assignment={assignment}
                      />
                    );
                  })}
                </ul>
              )}
              {printStructure(obj.id)}
            </li>
          );

          return sortedTeachingStructureLocal;
        })}
      </ul>
    );

    return sortedTeachingStructure;
  };
  useEffect(() => {
    if (teachingStructureLoading === 'success') {
      if (!lessonId) {
        const lessonsWithAssignments = teachingStructure.filter(obj => {
          return obj.assignments.length > 0;
        });

        if (!lessonsWithAssignments.length) {
          return;
        }

        routePush({
          search: {
            lesson: lessonsWithAssignments[0].assignments[0].id,
            type: 'material',
          },
        });
      }

      printStructure(parentId);
    }
  }, [teachingStructureLoading]);
  return (
    <div>
      <Card>
        <Card.Body className={`${style.cardContent}`}>
          <div
            className={classNames(
              'flex column gap-1 pl-1 pr-1 justify-between align-center border-b border-slate-600 sm-flex-col',
              style.cardDivContent
            )}
          >
            <h3>{query.title}</h3>
            <TeachingStructureHeader callback={getStructure} />
          </div>
          <div className={style.cardCont}>
            {teachingStructureLoading === 'success' ? printStructure(parentId) : null}
            {!lessonId && query.newItem === 'true' && <NewStructureItem callback={getStructure} />}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TeachingStructure;
